import {message, notification} from "ant-design-vue";

export function showError(title = "错误", content = "服务器错误") {
    notification.destroy();
// 请求失败,弹窗提示
    notification.error({
        message: title,
        description: content
    })
}

export function showSuccess(title = "通知", content = "操作成功") {
    notification.destroy();
    notification.success({
        message: title,
        description: content,
        duration: 2
    })
}

export function showWarning(title = "通知", content = "操作成功", duration = 2) {
    notification.destroy();
    notification.warning({
        message: title,
        description: content,
        duration: duration
    })
}

export function showMsg(content = "操作成功") {
    message.destroy();
    message.info(content)
}

export function showSuccessMsg(content = "操作成功") {
    message.destroy();
    message.success(content)
}

export function showErrorMsg(content = "操作失败") {
    message.destroy();
    message.error(content)
}

export function showWaringMsg(content = "操作失败") {
    message.destroy();
    message.warning(content)
}
